<template>
    <RbacDisplayGuard :features="config.requiredFeatures">
        <ExpandableItem
            :icon="config.icon"
            :icon-props="config.iconProps"
            :label="config.label"
            :disabled="config.disabled"
            @click="config.action(); $emit('item-clicked')"
        >
            <slot />
        </ExpandableItem>
    </RbacDisplayGuard>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

    import { EidIconFontAwesomeProps } from '@evidentid/dashboard-commons/components/EidIcon/types';
    import RbacDisplayGuard from '@evidentid/dashboard-commons/modules/role-base-access-control/components/rbac-guard/RbacDisplayGuard.vue';
    import { RbacFeature } from '@evidentid/tprm-portal-lib/models/rbac';

    import ExpandableItem from '@/components/expandable-item/ExpandableItem.vue';

    export default defineComponent({
        name: 'ActionButtonItemWrapper',
        components: { RbacDisplayGuard, ExpandableItem },
        props: {
            config: {
                type: Object as PropType<{
                    label: string;
                    requiredFeatures: RbacFeature[];
                    action: () => void;
                    disabled?: boolean;
                    icon?: IconDefinition;
                    iconProps?: EidIconFontAwesomeProps;
                }>,
                required: true,
            },
        },
        // PRODUCT-26110 Task 13: this component's template root is RbacDisplayGuard,
        // whose render() always returns a Fragment (see RbacDisplayGuard.vue's comment).
        // ActionsButton.vue binds `@item-clicked` on every usage; without a declared
        // `emits`, Vue 3 treats it as an extraneous listener it must forward through the
        // Fragment root and warns when it can't -- declaring it here marks it consumed at
        // this hop instead.
        emits: [ 'item-clicked' ],
    });
</script>
